const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1"]);

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, "");

export const isLocalBrowser = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  return LOCAL_HOSTNAMES.has(window.location.hostname);
};

export const getApiBaseUrl = (): string => {
  const configuredServerUrl = trimTrailingSlash(process.env.REACT_APP_SERVER_URL ?? "");
  const configuredBaseUrl = trimTrailingSlash(process.env.REACT_APP_BASE_URL ?? "");

  if (isLocalBrowser()) {
    const localPort = process.env.REACT_APP_LOCAL_SERVER_PORT ?? "5001";
    return `http://localhost:${localPort}`;
  }

  if (configuredServerUrl) {
    return configuredServerUrl;
  }

  if (configuredBaseUrl) {
    return configuredBaseUrl;
  }

  if (typeof window !== "undefined") {
    return trimTrailingSlash(window.location.origin);
  }

  return "";
};

export const getAuthRequestTimeoutMs = (): number => (isLocalBrowser() ? 3000 : 8000);
